export default {
  // Navigation
  nav_home: 'Home',
  nav_shopping_guide: 'Shopping Guide',
  nav_categories: 'Categories',
  nav_guides: 'Guides',
  nav_reviews: 'Reviews',
  nav_shipping: 'Shipping',
  nav_qc: 'QC',
  nav_safety: 'Safety',
  nav_faq: 'FAQ',
  nav_contact: 'Contact',
  nav_language: 'Language',

  // Hero
  hero_eyebrow: 'INDEPENDENT RESOURCE HUB',
  hero_title: 'CSSBuy Spreadsheet: Find, Compare & Research Products',
  hero_subtitle: 'Explore an independent CSSBuy Spreadsheet resource covering products, QC, shipping costs, warehouse guidance, reviews and practical buying tutorials.',
  cta_explore: 'Explore CSSBuy Spreadsheet',
  cta_guide: 'Read CSSBuy Guide',
  cta_main_site: 'Visit Main Website',
  cta_buy_now: 'Buy It Now',
  cta_cssbuy_spreadsheet: 'CSSBuy Spreadsheet',

  // Categories
  categories_title: 'Explore Product Categories',
  categories_subtitle: 'Browse by category and find what you need through our organized resource hub.',
  categories_all: 'All Categories',
  category_shoes: 'Shoes',
  category_hoodies: 'Hoodies/Sweaters',
  category_tshirts: 'T-Shirts',
  category_jackets: 'Jackets',
  category_pants: 'Pants/Shorts',
  category_headwear: 'Headwear',
  category_sets: 'Sets',
  category_underwear: 'Underwear/Underpants',
  category_jersey: 'Jersey',
  category_accessories: 'Accessories',
  category_bags: 'Bags',
  category_belts: 'Belts',
  category_perfumes: 'Perfumes',
  category_other: 'Other Stuff',

  // What is CSSBuy Spreadsheet
  what_is_title: 'What is CSSBuy Spreadsheet?',
  what_is_text: 'The CSSBuy Spreadsheet is a practical way to organize and research products, categories, seller information and purchase references. We have compiled independent guides to help you understand products, QC, shipping, warehouse and other important aspects before making a purchase.',

  // Value props
  value_title: 'Everything You Need Before You Buy',
  value_spreadsheet: 'Find and organize product information.',
  value_qc: 'Learn how to analyze photos and details before shipping.',
  value_shipping: 'Understand costs, methods and factors affecting shipping.',
  value_warehouse: 'Understand storage, inspection and consolidation.',
  value_review: 'Consult independent reviews and information.',
  value_safety: 'Learn to identify suspicious links, scams and fake accounts.',

  // How it works
  how_title: 'How to Use CSSBuy Spreadsheet',
  how_step1: 'Search for a product or category.',
  how_step2: 'Compare the information.',
  how_step3: 'Verify seller and details.',
  how_step4: 'Check QC.',
  how_step5: 'Analyze shipping costs and methods.',
  how_step6: 'Confirm current information.',
  how_step7: 'Continue to the main website if desired.',
  how_cta: 'Start Researching',

  // Articles
  articles_title: 'Popular Guides & Articles',
  articles_subtitle: 'In-depth resources to help you make informed decisions.',
  article_spreadsheet_guide: 'CSSBuy Spreadsheet Complete Guide',
  article_spreadsheet_guide_desc: 'A comprehensive guide to understanding and using CSSBuy Spreadsheet effectively.',
  article_review: 'CSSBuy Review 2026',
  article_review_desc: 'Independent review covering shipping, QC, costs, warehouse and safety.',
  article_shipping: 'CSSBuy Shipping Cost Guide',
  article_shipping_desc: 'Understand shipping costs, methods, weight calculations and delivery times.',
  article_qc: 'CSSBuy QC Guide',
  article_qc_desc: 'Learn how to read QC photos, check measurements and verify product details.',
  article_warehouse: 'CSSBuy Warehouse Guide',
  article_warehouse_desc: 'Understand storage, inspection, consolidation and warehouse fees.',
  article_coupon: 'CSSBuy Coupon & Discount Code',
  article_coupon_desc: 'How coupons and discount codes work and how to verify them safely.',
  article_legit: 'Is CSSBuy Legit?',
  article_legit_desc: 'An honest look at CSSBuy legitimacy, safety and what to expect.',
  article_beginners: 'CSSBuy Spreadsheet for Beginners',
  article_beginners_desc: 'A simple starting guide for first-time CSSBuy Spreadsheet users.',
  article_buying: 'CSSBuy Buying Guide',
  article_buying_desc: 'Step-by-step guidance for a safe and informed purchase.',
  article_methods: 'CSSBuy Shipping Methods',
  article_methods_desc: 'Compare shipping methods, speeds and cost factors.',
  article_qc_checklist: 'CSSBuy QC Checklist',
  article_qc_checklist_desc: 'A practical checklist for reviewing QC photos and details.',
  article_seller: 'CSSBuy Seller Guide',
  article_seller_desc: 'How to verify sellers and spot reliable sources.',
  article_safety_guide: 'CSSBuy Safety Guide',
  article_safety_guide_desc: 'Essential safety practices to protect your account and money.',
  article_faq_guide: 'CSSBuy Spreadsheet FAQ',
  article_faq_guide_desc: 'Answers to the most common CSSBuy Spreadsheet questions.',
  read_article: 'Read Article',

  // Shipping
  shipping_title: 'CSSBuy Shipping Cost: Understand the Key Costs',
  shipping_text: 'The final cost may vary depending on destination, weight, volume, shipping method, insurance, packaging and other factors. Always check current values before confirming your order.',
  shipping_cta: 'View Shipping Guide',

  // Safety
  safety_title: 'Shop and Research More Safely',
  safety_text: 'Verify sources, sellers, links and information before buying. Never share passwords, authentication codes or financial information with unverified accounts.',
  safety_cta: 'Visit Safety Center',

  // FAQ
  faq_title: 'Frequently Asked Questions about CSSBuy Spreadsheet',
  faq_q1: 'What is CSSBuy Spreadsheet?',
  faq_a1: 'CSSBuy Spreadsheet is an organized resource that helps users research products, categories, sellers and purchase information before buying through CSSBuy.',
  faq_q2: 'How to use CSSBuy Spreadsheet?',
  faq_a2: 'Start by searching for a product or category, compare information, verify seller details, check QC photos and understand shipping costs before proceeding.',
  faq_q3: 'Is CSSBuy legit?',
  faq_a3: 'CSSBuy is a known shopping agent service. This website provides independent guides and resources to help users make informed decisions.',
  faq_q4: 'Is CSSBuy safe?',
  faq_a4: 'Safety depends on following best practices: verifying sellers, checking QC, understanding shipping and never sharing sensitive information.',
  faq_q5: 'How much does shipping cost?',
  faq_a5: 'Shipping costs vary by destination, weight, volume, method and other factors. Always check current rates before ordering.',
  faq_q6: 'How does the warehouse work?',
  faq_a6: 'The warehouse stores your items, performs inspections, takes QC photos and consolidates packages before shipping.',
  faq_q7: 'What does QC mean?',
  faq_a7: 'QC stands for Quality Control. It involves checking product photos, measurements and details before the item is shipped to you.',
  faq_q8: 'How to verify a seller?',
  faq_a8: 'Check seller ratings, reviews, transaction history and verify product details through multiple sources before purchasing.',
  faq_cta: 'View All Questions',

  // Final CTA
  final_cta_title: 'Ready to Start Your Research?',
  final_cta_text: 'Explore CSSBuy Spreadsheet, compare information and consult our guides before making your decision.',
  final_cta_explore: 'Explore CSSBuy Spreadsheet',
  final_cta_main: 'Continue to Main Website',

  // Footer
  footer_tagline: 'Independent CSSBuy Spreadsheet Resource Hub',
  footer_resources: 'Resources',
  footer_cssbuy_spreadsheet: 'CSSBuy Spreadsheet',
  footer_cssbuy_review: 'CSSBuy Review',
  footer_cssbuy_shipping: 'CSSBuy Shipping',
  footer_cssbuy_shipping_cost: 'CSSBuy Shipping Cost',
  footer_cssbuy_qc: 'CSSBuy QC',
  footer_cssbuy_warehouse: 'CSSBuy Warehouse',
  footer_cssbuy_coupon: 'CSSBuy Coupon',
  footer_cssbuy_discount: 'CSSBuy Discount Code',
  footer_cssbuy_legit: 'CSSBuy Legit',
  footer_cssbuy_safety: 'CSSBuy Safety',
  footer_guides: 'Guides',
  footer_comparisons: 'Comparisons',
  footer_faq: 'FAQ',
  footer_legal: 'Legal',
  footer_privacy: 'Privacy',
  footer_terms: 'Terms',
  footer_disclaimer: 'Disclaimer',
  footer_contact: 'Contact',
  footer_languages: 'Languages',
  footer_english: 'English',
  footer_portuguese: 'Portuguese (BR)',
  footer_german: 'German',
  footer_copyright: 'cssbuybr.help is an independent resource. Not affiliated with CSSBuy.',

  // Trust strip
  trust_independent: 'Independent Guides',
  trust_organized: 'Organized Information',
  trust_updated: 'Regularly Updated',

  // Meta
  meta_title: 'CSSBuy Spreadsheet: Guides, Reviews, QC & Shipping',
  meta_description: 'Explore an independent CSSBuy Spreadsheet resource covering products, reviews, QC, shipping costs, warehouse guides and practical buying tips.',
};